import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#334155'
    }}>
      <Link 
        to="/"
        style={{
          display: 'inline-block',
          marginBottom: '20px',
          color: '#2980b9',
          textDecoration: 'none'
        }}
      >
        ← Back to Home
      </Link>

      <h1 style={{ textAlign: 'center' }}>Pulc AI Privacy Policy</h1>

      <p>We at Pulc AI respect your privacy and are strongly committed to keeping secure any information we obtain from you or about you. This Privacy Policy describes our practices with respect to Personal Data we collect from or about you when you use our website, applications, and services (collectively, "Services").</p>

      <h2>1. Data controller</h2>
      <p>Pulc AI Limited is the controller and is responsible for the processing of your Personal Data as described in this Privacy Policy.</p>

      <h2>2. Personal Data we collect</h2>
      <p>We collect personal data relating to you ("Personal Data") as described below:</p>

      <h3>Personal Data You Provide:</h3>
      <ul>
        <li><strong>Account Information:</strong> When you create an account with us, we collect information associated with your account, including your name, contact information, account credentials, payment card information, and transaction history.</li>
        <li><strong>User Content:</strong> When you use our Services, we collect Personal Data that is included in the input, file uploads, or feedback that you provide to our Services.</li>
        <li><strong>Communication Information:</strong> If you communicate with us, we collect your name, contact information, and the contents of any messages you send.</li>
        <li><strong>Social Media Information:</strong> We have pages on social media sites like Instagram, Facebook, Medium, X, YouTube and LinkedIn. When you interact with our social media pages, we collect Personal Data that you choose to provide to us.</li>
      </ul>

      <h3>Personal Data We Receive Automatically:</h3>
      <ul>
        <li><strong>Log Data:</strong> Information that your browser automatically sends when you use our Services, including IP address, browser type and settings, date and time of requests.</li>
        <li><strong>Usage Data:</strong> Information about your use of the Services, including features used and actions taken.</li>
        <li><strong>Device Information:</strong> Information about your device, including operating system and browser type.</li>
        <li><strong>Cookies and Similar Technologies:</strong> We use cookies to operate and improve our Services.</li>
      </ul>

      <h2>3. How we use Personal Data</h2>
      <p>We may use Personal Data for the following purposes:</p>
      <ul>
        <li>To provide and maintain our Services</li>
        <li>To improve and develop our Services and conduct research</li>
        <li>To communicate with you about our Services and events</li>
        <li>To prevent fraud and protect our Services</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2>4. Disclosure of Personal Data</h2>
      <p>We may disclose your Personal Data in the following circumstances:</p>
      <ul>
        <li><strong>Vendors and Service Providers:</strong> To assist us in meeting business operations needs and to perform certain services and functions, we may share Personal Data with vendors and service providers, including providers of hosting services, cloud services, and other information technology providers.</li>
        <li><strong>Business Transfers:</strong> If we are involved in strategic transactions, reorganization, bankruptcy, receivership, or transition of service to another provider, your Personal Data may be transferred as part of that transaction.</li>
        <li><strong>Legal Requirements:</strong> We may share your Personal Data to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request.</li>
      </ul>

      <h2>5. Retention</h2>
      <p>We'll retain your Personal Data for only as long as we need in order to provide our Service to you, or for other legitimate business purposes such as resolving disputes, safety and security reasons, or complying with our legal obligations. How long we retain Personal Data will depend on a number of factors, such as:</p>
      <ul>
        <li>Our purpose for processing the data</li>
        <li>The amount, nature, and sensitivity of the data</li>
        <li>The potential risk of harm from unauthorized use or disclosure</li>
        <li>Any legal requirements that we are subject to</li>
      </ul>

      <h2>6. Your Rights</h2>
      <p>You have the following rights in relation to your Personal Data:</p>
      <ul>
        <li>Access your Personal Data</li>
        <li>Delete your Personal Data from our records</li>
        <li>Rectify or update your Personal Data</li>
        <li>Transfer your Personal Data to a third party</li>
        <li>Restrict how we process your Personal Data</li>
        <li>Withdraw your consent at any time</li>
        <li>Lodge a complaint with your local data protection authority</li>
      </ul>
      <p>You can exercise some of these rights through your Pulc AI account. If you are unable to exercise your rights through your account, please submit your request by emailing <a href="mailto:hello@pulc.ie" style={{ color: '#2980b9' }}>hello@pulc.ie</a></p>

      <p>We hope that we are able to address any questions or concerns you may have. If you have any unresolved complaints with us or our Data Protection Officer, you can reach out to the <a href="https://www.dataprotection.ie" target="_blank" rel="noopener noreferrer" style={{ color: '#2980b9' }}>Irish Data Protection Commission</a> as our lead supervisory authority.</p>
      <h2>7. Children</h2>
      <p>Our Services are not directed to, or intended for, children under 13. We do not knowingly collect Personal Data from children under 13. </p>

      <h2>8. Legal Bases for Processing</h2>
      <p>When we process your Personal Data, we rely on the following legal bases:</p>
      <ul>
        <li>Performance of a contract when we provide you with our Services</li>
        <li>Legitimate interests in operating and improving our Services</li>
        <li>Compliance with our legal obligations</li>
        <li>Your consent, when we request it</li>
      </ul>

      <h2>9. Data Transfers</h2>
      <p>Your Personal Data may be stored and processed in any country where we have operations or where we engage service providers. We may transfer Personal Data to countries outside of your country of residence, which may have different data protection rules.</p>

      <h2>10. Changes to the Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. When we do, we will post an updated version on this page, unless another type of notice is required by applicable law.</p>

     

      <h2>11. How to Contact Us</h2>
      <p>Please write to us at <a href="mailto:hello@pulc.ie" style={{ color: '#2980b9' }}>hello@pulc.ie</a></p>

      <div style={{ marginTop: '40px', fontSize: '0.9em', color: '#64748b' }}>
        <p>Last updated: February 2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 